import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { IoMdAddCircleOutline } from 'react-icons/io'
import { FaEdit, FaRegPlusSquare } from 'react-icons/fa'
import { customersService } from '../../_services/customers.service'
import AsyncSelect from 'react-select'

class AsyncClientSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      defaultValue: '',
      data: [],
      value: '',
      keyword: '',
      formDialog: false
    }
  }

  componentWillMount() {
    this.getData()
  }

  getData() {
    // var dto = {
    //   "page": 1,
    //   "pageSize": 10,
    //   "brandName": "",
    //   "categoryTypeIds": []
    // }
    customersService
      .getAll()
      .then(res => {
        // console.log(res.data)
        let data = res.data.map(elm => ({
          label: elm.title,
          value: elm.id
        }))
        this.setState({ data: data, loading: false, isSubmitting: false })
      })
      .catch(error => {
        console.log(error)
      })
  }

  handleChange = e => {
    // console.log(e);
    this.setState({ value: e.value, selectedValue: e.value }, () => {
      this.props.onChange(e)
    })
  }

  // handleInputChange = val => {
  //   if (val !== undefined && val.length > 0) {
  //     this.setState({
  //       keyword: val,
  //       data: [],
  //       loading: true,
  //       isSubmitting: false
  //     })
  //     var dto = {
  //       keyword: val
  //     }

  //     clientsService
  //       .search(JSON.stringify(dto))
  //       .then(res => {
  //         console.log(dto)
  //         console.log(res.data)

  //         let data = res.data.map(elm => ({
  //           label: elm.name + (elm.tel ? ' (' + elm.tel + ')' : ''),
  //           value: elm.id
  //         }))

  //         this.setState({ data: data, loading: false, isSubmitting: false })
  //       })
  //       .catch(error => {
  //         // console.log(error);
  //         this.setState({ data: [], loading: false, isSubmitting: false })
  //       })
  //   }
  // }

  componentWillReceiveProps(nextProps) {
    // if (nextProps.data !== this.state.data) {

    //   this.setState({ data: nextProps.data });

    // }

    if (nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value })
    }
  }

  handleModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ formDialog: false })
  }

  handleModalHideAndReload = e => {
    this.getData()
    this.setState({ formDialog: false })
  }

  handleCreateClient = () => {
    this.setState({ formDialog: true })
  }

  handleCreateClient = () => {
    this.setState({ selectedValue: undefined, formDialog: true })
  }

  handleEditClient = () => {
    this.setState({ formDialog: true })
  }

  render() {
    const customStyles = {
      control: provided => ({
        ...provided,
        background: '#f6f6f6',
        borderRadius: 20,
        boxShadow: 'none',
        border: 'none',
        paddingRight: '12',
        border: 'thin solid #e1e1e1 '
      }),
      noOptionsMessage: provided => ({
        ...provided,
        fontSize: '12px'
      }),
      indicatorSeparator: () => ({
        display: 'none'
      })
    }
    const { loading, data, value, keyword, selectedValue } = this.state
    const { disabled, required, placeholder, tabIndex, type } = this.props

    return (
      <>
        <div className="client-select-container">
          <AsyncSelect
            cacheOptions
            tabIndex={tabIndex}
            classNamePrefix="select"
            // loadOptions={this.loadOptions}
            // defaultOptions
            // menuIsOpen={true}
            placeholder={placeholder || ''}
            isDisabled={disabled}
            styles={customStyles}
            options={data}
            // onInputChange={this.handleInputChange}
            className={required ? 'select required' : 'select'}
            value={data ? data.filter(e => e.value === value)[0] : ''}
            onChange={this.handleChange}
            noOptionsMessage={() =>
              keyword.length > 0 && (!data || data.length === 0)
                ? 'نتیجه ای یافت نشد'
                : 'نام یا تلفن طرف حساب را وارد نمایید'
            }
            loadingMessage={() => 'در حال دریافت اطلاعات از سرور'}
            isLoading={loading}
          />
          {/* {selectedValue ? (
            <a onClick={() => this.handleEditClient()}>
              <FaEdit size="24px" />
            </a>
          ) : (
            ''
          )} */}
          {/* <a onClick={() => this.handleCreateClient()}>
            <FaRegPlusSquare size="22px" />
          </a> */}
        </div>
        {/* <ClientFormDialog
          show={this.state.formDialog}
          id={selectedValue}
          handleModalHide={() => this.handleModalHide()}
          handleModalHideAndReload={() => this.handleModalHideAndReload()}
        /> */}
      </>
    )
  }
}
export default AsyncClientSelect
